module.exports = __webpack_public_path__ + "static/media/illustration-2.c8758110.png";